import React, { useEffect } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import PropTypes from 'prop-types';
import { object } from 'yup';
import { TextInput } from '../../../Helpers/Inputs';
import NumberFormatDollarMonth from '../../../Helpers/Formatters/NumberFormatDollarMonth';
import RulerIcon from '../../../../../src/icons/icRuler.svg';
import BasicDetails from '../../BasicDetails';
import { number as yupnumber } from "../../../Helpers/Validators/customValidators";
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import BackNextButton from '../../../Common/BackNextButton';
import FormHeader from './FormHeader';

export default function MonthlyExpenses(props) {
  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: MonthlyExpenses.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    register({ name: 'mortgageExpense' });
    setValue('mortgageExpense', props.formState.mortgageExpense);

    register({ name: 'additionalExpense' });
    setValue('additionalExpense', props.formState.additionalExpense);

    register({ name: 'nonEssentialExpense' });
    setValue('nonEssentialExpense', props.formState.nonEssentialExpense);
  }, [register]);

  return (
    <div>
      <Container fluid className="border-class">
        <Form onSubmit={handleSubmit(props.onNext)}>
        {props.StartOverButton}
          <Row className="justify-content-center pt-3 client-coverage">
            <Col lg={4}>
            <FormHeader title="Client's Monthly Expenses"   Icon={RulerIcon} />
            <Form.Group>
                <TextInput
                  name="mortgageExpense"
                  id="mortgageExpense"
                  label="Client's Mortgage / Rent"
                  value={props.formState.mortgageExpense}
                  errors={errors && errors.mortgageExpense}
                  inputRef={register}
                  onChange={e => handleValueChange('mortgageExpense', e.target.value)}
                  InputProps={{
                    inputComponent: NumberFormatDollarMonth
                  }}
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="additionalExpense"
                  id="additionalExpense"
                  label="Client's Other Essential Expenses"
                  value={props.formState.additionalExpense}
                  errors={errors && errors.additionalExpense}
                  inputRef={register}
                  onChange={e => handleValueChange('additionalExpense', e.target.value)}
                  InputProps={{
                    inputComponent: NumberFormatDollarMonth
                  }}
                />
              </Form.Group>

              <Form.Group>
                <TextInput
                  name="nonEssentialExpense"
                  id="nonEssentialExpense"
                  label="Client’s Discretionary Expenses"
                  value={props.formState.nonEssentialExpense}
                  errors={errors && errors.nonEssentialExpense}
                  inputRef={register}
                  onChange={e => handleValueChange('nonEssentialExpense', e.target.value)}
                  InputProps={{
                    inputComponent: NumberFormatDollarMonth
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <BackNextButton onBack={props.onBack} />
        </Form>
      </Container>
      <BasicDetails
        fullFormState={props.fullFormState}
      />
    </div>
  );
}

MonthlyExpenses.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired
};

MonthlyExpenses.ValidationSchema = object().shape({
  mortgageExpense: yupnumber()
    .transform(emptyStringToUndefined)
    .required("This field is required.")
    .max(25000, "Amount must be less than or equal to $25,000."),
  additionalExpense: yupnumber()
    .transform(emptyStringToUndefined)
    .required("This field is required.")
    .max(25000, "Amount must be less than or equal to $25,000."),
  nonEssentialExpense: yupnumber()
    .transform(emptyStringToUndefined)
    .required("This field is required.")
    .max(25000, "Amount must be less than or equal to $25,000."),
});

MonthlyExpenses.DefaultFormState = (prefill = false) => {
  return {
    mortgageExpense: prefill ? '1250' : '',
    additionalExpense: prefill ? '1250' : '',
    nonEssentialExpense: prefill ? '4250' : ''
  };
};



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/steps/MonthlyExpenses.js